const THEME_UTIL = {
  goldGradientMain:
    'linear-gradient(90deg, #A17B11 0%, #EDC650 38%, #B28E22 100%)',
  goldGradientLight:
    'linear-gradient(90deg, #AE8625 0%, #F7EF8A 30%, #D2AC47 73%, #EDC967 100%)',
  telegramColor: '#229ED9',
  facebookColor: '#1877F2',
};

export default THEME_UTIL;
